import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Slot recipe for the header cart CTA.
 *
 * - `badge` is the item-count notification pinned to the icon's bottom-right
 *   corner, only rendered when the basket has items.
 *
 * The round icon-button chrome (36×36, hover, focus-ring) is owned by
 * `header-icon-button` (STOK-17031 Step 10), which this CTA renders through;
 * this recipe only covers the badge positioning.
 */
export const cartCtaRecipe = defineSlotRecipe({
    slots: ['badge'],
    base: {
        badge: {
            // Cart-notification per Figma (node 24945:30852): a round,
            // brand-orange (`primary.brand.500` = #ED7703) badge with centred
            // white text pinned to the bottom-right of the icon.
            position: 'absolute',
            bottom: 'spacing-5',
            right: 'spacing-5',
            borderRadius: 'full',
            bg: 'primary.brand.500',
            color: 'primary.base.white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            pointerEvents: 'none',
            // not per figma, but allows for multi-character badge
            paddingBlock: 'spacing-2',
            paddingInline: 'spacing-4',
            minWidth: 'spacing-12',
            minHeight: 'spacing-12',
            // DESIGN-ISSUE(STOK-17031): the badge's 8px count text is not covered
            // by any `textStyle` in the style guide; the family/weight/size stay
            // literals until design provides a token for this micro-label.
            fontFamily: 'Stokke',
            fontWeight: '400',
            fontSize: '0.5rem', // 8px
            lineHeight: '0.5rem' // 8px
        }
    }
})
